module.exports = __webpack_public_path__ + "static/media/darkforces.3411898c.gif";